export const createRainEffect = (effectLayer, settings) => {
  try {
    const effectWidth = effectLayer.getBoundingClientRect().width;
    const effectHeight = effectLayer.getBoundingClientRect().height;
    const defaultDropCount = settings.intensity || 100;

    class WaterDrop {
      constructor(xPosition, yPosition, dropSpeed, dropWidth, dropHeight) {
        this.xPosition = xPosition;
        this.yPosition = yPosition;
        this.dropSpeed = dropSpeed;
        this.dropWidth = dropWidth;
        this.dropHeight = dropHeight;
        this.element = null;
      }

      show() {
        this.element = document.createElement('div');
        this.element.style.position = 'absolute';
        this.element.style.background = 'linear-gradient(180deg, #c3e8de, #5abcd8, #1ca3ec)';
        this.element.style.borderRadius = '100% 100% 80% 80%';
        this.element.style.top = `${this.yPosition}px`;
        this.element.style.left = `${this.xPosition}px`;
        this.element.style.width = `${this.dropWidth}px`;
        this.element.style.height = `${this.dropHeight}px`;
        const oneDrop = effectLayer;
        oneDrop.appendChild(this.element);
      }

      fall() {
        const makeRain = () => {
          this.yPosition = this.yPosition + this.dropSpeed;
          this.element.style.top = `${this.yPosition}px`;
          if (this.yPosition < effectHeight) {
            requestAnimationFrame(makeRain);
          } else {
            this.yPosition = -10;
            requestAnimationFrame(makeRain);
          }
        };
        requestAnimationFrame(makeRain);
      }
    }

    const makeRain = (count) => {
      while (effectLayer.hasChildNodes()) {
        effectLayer.removeChild(effectLayer.lastChild);
      }

      for (let i = 0; i < count; i += 1) {
        const randomX = Math.floor(Math.random() * (effectWidth));
        const randomY = Math.floor(Math.random() * (effectHeight));
        const dropSpeed = (settings.speed / 10) + (Math.floor(Math.random() * (25 - 5)));
        const dropSize = (Math.floor(Math.random() * settings.size)) || (Math.floor(Math.random() * 20));
        const dropWidth = Math.floor(Math.random() * ((dropSize / 5) - 1)) + 1;
        const dropHeight = Math.floor(Math.random() * ((dropSize * 2) - 3)) + 3;

        const waterDropObject = new WaterDrop(randomX, randomY, dropSpeed, dropWidth, dropHeight);

        waterDropObject.show();
        waterDropObject.fall();
      }
    };

    makeRain(defaultDropCount);
  } catch (e) {
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/effects/rain.js